import { find, findAll, register } from '../../../../Javascript/Sysmex/Utils'

const NotificationsToast = el => {
  const componentPrefix = el.dataset.componentprefix
  const notificationsIdentifier = el.dataset.notificationidentifier
  const cookieEnabled = el.dataset.cookieenabled
  const notificationDelay = +el.dataset.delay
  const expiryTime = +el.dataset.expirytime
  const closeLayers = findAll(`.${componentPrefix}closeLayer`, el)
  const buttonStyleOnLastLink = find(`.${componentPrefix}buttonStyleOnLastLink`, el)
  const content = find(`.${componentPrefix}content`, el)
  const notificationCookieName = componentPrefix + notificationsIdentifier
  const notificationCookie = document.cookie

  if (buttonStyleOnLastLink) {
    const link = content.getElementsByTagName('a')
    if (link.length !== 0) {
      const lastLink = link.item(link.length - 1)
      if (lastLink !== null) {
        const classes = ['sysmexAtomButton_button', 'sysmexAtomButton_button--isSmall', 'sysmexAtomButton_button--isOutlined', 'sysmexAtomButton_button--isWhite', 'sysmexAtomButton_button--hoverColor-green', `${componentPrefix}button`, `${componentPrefix}closeLayer`]
        classes.forEach(function (item) {
          return lastLink.classList.add(item)
        })
      }
    }
  }

  if (cookieEnabled) {
    if (!notificationCookie.match(notificationCookieName)) {
      setTimeout(() => {
        el.classList.add(`${componentPrefix}wrapperVisible`)
      }, notificationDelay)
    }

    closeLayers.forEach(closeLayer => {
      closeLayer.addEventListener('click', function () {
        el.classList.remove(`${componentPrefix}wrapperVisible`)
        let expiryDate = 0
        if (expiryTime > 0) {
          expiryDate = new Date()
          expiryDate.setDate(expiryDate.getDate() + expiryTime)
          expiryDate = expiryDate.toUTCString()
        }
        document.cookie = `${notificationCookieName}=true; path=/; expires=${expiryDate}`
      })
    })
  } else {
    el.classList.add(`${componentPrefix}wrapperVisible`)
    closeLayers.forEach(closeLayer => {
      closeLayer.addEventListener('click', function () {
        el.classList.remove(`${componentPrefix}wrapperVisible`)
      })
    })
  }
}

register('NotificationsToast', NotificationsToast)
